/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteMaintenanceRecordsParams,
  GetMaintenanceRecordsParams,
  MaintenanceRecords,
  MaintenanceRecordsInsertPayload,
  MaintenanceRecordsUpdate,
  PatchMaintenanceRecordsParams,
  PostMaintenanceRecordsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getMaintenanceRecordsResponse200 = {
  data: MaintenanceRecords[]
  status: 200
}

export type getMaintenanceRecordsResponse206 = {
  data: MaintenanceRecords[]
  status: 206
}

export type getMaintenanceRecordsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getMaintenanceRecordsResponseSuccess = (getMaintenanceRecordsResponse200 | getMaintenanceRecordsResponse206) & {
  headers: Headers;
};
export type getMaintenanceRecordsResponseError = (getMaintenanceRecordsResponseDefault) & {
  headers: Headers;
};

export type getMaintenanceRecordsResponse = (getMaintenanceRecordsResponseSuccess | getMaintenanceRecordsResponseError)

export const getGetMaintenanceRecordsUrl = (params?: GetMaintenanceRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_records?${stringifiedParams}` : `${backendBaseUrl}/maintenance_records`
}

/**
 * @summary Read rows from `maintenance_records`.
 */
export const getMaintenanceRecords = async (params?: GetMaintenanceRecordsParams, options?: RequestInit): Promise<getMaintenanceRecordsResponse> => {

  const res = await fetch(getGetMaintenanceRecordsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMaintenanceRecordsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getMaintenanceRecordsResponse
}


export type postMaintenanceRecordsResponse201 = {
  data: MaintenanceRecords[]
  status: 201
}

export type postMaintenanceRecordsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postMaintenanceRecordsResponseSuccess = (postMaintenanceRecordsResponse201) & {
  headers: Headers;
};
export type postMaintenanceRecordsResponseError = (postMaintenanceRecordsResponseDefault) & {
  headers: Headers;
};

export type postMaintenanceRecordsResponse = (postMaintenanceRecordsResponseSuccess | postMaintenanceRecordsResponseError)

export const getPostMaintenanceRecordsUrl = (params?: PostMaintenanceRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_records?${stringifiedParams}` : `${backendBaseUrl}/maintenance_records`
}

/**
 * @summary Insert one or more rows into `maintenance_records`.
 */
export const postMaintenanceRecords = async (maintenanceRecordsInsertPayload: MaintenanceRecordsInsertPayload,
    params?: PostMaintenanceRecordsParams, options?: RequestInit): Promise<postMaintenanceRecordsResponse> => {

  const res = await fetch(getPostMaintenanceRecordsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceRecordsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postMaintenanceRecordsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postMaintenanceRecordsResponse
}


export type patchMaintenanceRecordsResponse200 = {
  data: MaintenanceRecords[]
  status: 200
}

export type patchMaintenanceRecordsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchMaintenanceRecordsResponseSuccess = (patchMaintenanceRecordsResponse200) & {
  headers: Headers;
};
export type patchMaintenanceRecordsResponseError = (patchMaintenanceRecordsResponseDefault) & {
  headers: Headers;
};

export type patchMaintenanceRecordsResponse = (patchMaintenanceRecordsResponseSuccess | patchMaintenanceRecordsResponseError)

export const getPatchMaintenanceRecordsUrl = (params?: PatchMaintenanceRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_records?${stringifiedParams}` : `${backendBaseUrl}/maintenance_records`
}

/**
 * @summary Update the rows of `maintenance_records` matching the given filters.
 */
export const patchMaintenanceRecords = async (maintenanceRecordsUpdate: MaintenanceRecordsUpdate,
    params?: PatchMaintenanceRecordsParams, options?: RequestInit): Promise<patchMaintenanceRecordsResponse> => {

  const res = await fetch(getPatchMaintenanceRecordsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceRecordsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchMaintenanceRecordsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchMaintenanceRecordsResponse
}


export type deleteMaintenanceRecordsResponse200 = {
  data: MaintenanceRecords[]
  status: 200
}

export type deleteMaintenanceRecordsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteMaintenanceRecordsResponseSuccess = (deleteMaintenanceRecordsResponse200) & {
  headers: Headers;
};
export type deleteMaintenanceRecordsResponseError = (deleteMaintenanceRecordsResponseDefault) & {
  headers: Headers;
};

export type deleteMaintenanceRecordsResponse = (deleteMaintenanceRecordsResponseSuccess | deleteMaintenanceRecordsResponseError)

export const getDeleteMaintenanceRecordsUrl = (params?: DeleteMaintenanceRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_records?${stringifiedParams}` : `${backendBaseUrl}/maintenance_records`
}

/**
 * @summary Delete the rows of `maintenance_records` matching the given filters.
 */
export const deleteMaintenanceRecords = async (params?: DeleteMaintenanceRecordsParams, options?: RequestInit): Promise<deleteMaintenanceRecordsResponse> => {

  const res = await fetch(getDeleteMaintenanceRecordsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteMaintenanceRecordsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteMaintenanceRecordsResponse
}


